/*
 * BLACK NOVEMBER 2026 — Guante de regalo por importe de carrito (TwoFive)
 *
 * El regalo lo hace GRATIS Shopify con tres descuentos automáticos "Compra X, llévate Y":
 *   · desde 49,98 € (se comunica 49,99 €)   → 1 guante Basic   (Atlanta Basic Whiteout / Blackout / White HiVis)
 *   · desde 79,99 €                          → 1 guante Advance (Atlanta Advance Whiteout / Blackout / White HiVis)
 *   · desde 119,98 € (se comunica 119,99 €) → 1 guante Pro     (Atlanta Pro Flat / Los Angeles Pro Yellow HiVis / New York Pro Orange HiVis)
 * Solo cuenta la franja más alta alcanzada (1 regalo por pedido).
 *
 * Cada franja tiene un producto regalo propio (oculto) con opciones Modelo y Talla; cada variante es un
 * paquete nativo de Shopify cuyo componente es el guante real, así el stock es siempre el del guante real.
 *
 * Este script solo gestiona la experiencia en la tienda:
 *   1. Pinta un bloque en el carrito lateral y en /cart: barra de progreso, mensaje y
 *      selector de modelo + talla del guante de regalo (solo tallas con stock).
 *   2. Añade la variante elegida del producto regalo con la propiedad "Regalo: Black November".
 *   3. Mantiene el carrito coherente tras cualquier cambio:
 *        · por debajo de la primera franja → quita el regalo
 *        · cambia de franja → cambia el regalo por el equivalente de la nueva franja
 *          (Whiteout↔Whiteout, Blackout↔Blackout, White HiVis↔White HiVis, misma talla, si hay stock);
 *          si no hay equivalente (p. ej. al pasar a Pro) se quita y el cliente elige de nuevo
 *        · máximo 1 regalo y cantidad 1
 *   4. Códigos de descuento: el regalo no es acumulable con códigos (Shopify aplica solo el que más ahorra).
 *      Si hay un código aplicado y el regalo deja de ser gratis, se quita el regalo del carrito y se explica
 *      al cliente, con un botón para quitar el código y elegir el regalo. (Si el código se mete directamente
 *      en el checkout, el carrito no se entera: ahí decide Shopify.)
 *   5. Vista previa antes de la campaña: ?bn_preview=1 en cualquier URL (?bn_preview=0 para quitarla).
 *
 * Importe que cuenta = mismas reglas que los descuentos de Shopify: todos los productos del carrito sin envío,
 * salvo las líneas de regalo, la familia «Servicios y cargos» y las tarjetas regalo.
 * Los mensajes al cliente usan los importes que se comunican (49,99 / 79,99 / 119,99 €).
 * La configuración (franjas, variantes con stock) llega desde snippets/bn-gift-config.liquid.
 * No modifica archivos del carrito: inserta el bloque en el DOM y usa las funciones del tema
 * (cart-drawer.renderContents / getSectionsToRender) para repintar sin recargar.
 */
(function () {
  'use strict';
  if (window.__bnGiftLoaded) return;
  window.__bnGiftLoaded = true;

  var cfgEl = document.getElementById('bn-gift-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[bn-gift] config inválida', e); return; }

  var LOG = '[bn-gift]';
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  // fetch del tema (ya parcheado por assets/cart.js). Nuestras llamadas van por aquí
  // y NO pasan por nuestro propio observador (definido más abajo).
  var baseFetch = window.fetch.bind(window);

  // ─── Vista previa ──────────────────────────────────────────────────
  var params = new URLSearchParams(window.location.search);
  if (params.has('bn_preview')) {
    var on = params.get('bn_preview') === '1';
    baseFetch('/cart/update.js', {
      method: 'POST', headers: JSON_HEADERS,
      body: JSON.stringify({ attributes: { _bn_preview: on ? '1' : '' } })
    }).catch(function () {}).then(function () {
      params.delete('bn_preview');
      var qs = params.toString();
      window.location.replace(window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    });
    return;
  }
  if (!CFG.enabled) return;

  // ─── Modelo de datos ────────────────────────────────────────────────
  var TIERS = (CFG.tiers || []).filter(function (t) { return t && t.productId; })
    .sort(function (a, b) { return a.min - b.min; });
  if (!TIERS.length) { console.warn(LOG, 'sin productos regalo publicados'); return; }
  var EXCLUDED_TYPES = CFG.excludedTypes || [];

  var TIER_BY_PRODUCT = {};   // id del producto regalo → franja
  var GIFT_VARIANT = {};      // id de variante regalo → { tier, model, size, family, available }
  TIERS.forEach(function (t) {
    t.show = t.show || t.min;
    t.variants = t.variants || [];
    TIER_BY_PRODUCT[t.productId] = t;
    t.variants.forEach(function (v) { v.tier = t; GIFT_VARIANT[v.id] = v; });
  });

  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  var money = function (cents) { return fmt.format(Math.max(0, cents) / 100); };
  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var isGiftLine = function (it) {
    return !!(TIER_BY_PRODUCT[it.product_id] ||
      (it.properties && it.properties[CFG.property] === CFG.propertyValue));
  };
  var counts = function (it) {
    return !it.gift_card && EXCLUDED_TYPES.indexOf(it.product_type) === -1;
  };
  var isCartPage = function () { return /\/cart\/?$/.test(window.location.pathname); };
  function giftLabel(line) {
    var v = GIFT_VARIANT[line.variant_id];
    if (v) return v.model + ' · Talla ' + v.size;
    return line.product_title + (line.variant_title ? ' · ' + line.variant_title : '');
  }

  // Importe que cuenta y franja alcanzada
  function analyse(cart) {
    var total = 0, gifts = [];
    (cart.items || []).forEach(function (it) {
      if (isGiftLine(it)) { gifts.push(it); return; }
      if (!counts(it)) return;
      total += it.original_line_price != null ? it.original_line_price : it.line_price;
    });
    var reached = null;
    TIERS.forEach(function (t) { if (total >= t.min) reached = t; });
    var next = TIERS[(reached ? TIERS.indexOf(reached) : -1) + 1] || null;
    var codes = (cart.discount_codes || []).filter(function (d) { return d && d.applicable; })
      .map(function (d) { return d.code; });
    return { total: total, tier: reached, next: next, gifts: gifts, codes: codes, count: cart.item_count || 0 };
  }

  function findSwapVariant(giftLine, targetTier) {
    var cur = GIFT_VARIANT[giftLine.variant_id];
    if (!cur) return null;
    for (var i = 0; i < targetTier.variants.length; i++) {
      var v = targetTier.variants[i];
      if (v.available && v.family === cur.family && String(v.size) === String(cur.size)) return v;
    }
    return null;
  }

  // ─── API carrito ───────────────────────────────────────────────────
  var lastCart = null;
  function getCart() {
    return baseFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; return c; });
  }
  function setQty(key, qty) {
    return baseFetch('/cart/change.js', {
      method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity: qty })
    });
  }
  function addGift(variantId) {
    var props = {}; props[CFG.property] = CFG.propertyValue;
    return baseFetch('/cart/add.js', {
      method: 'POST', headers: JSON_HEADERS,
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: props }] })
    });
  }

  // Repinta carrito lateral / página de carrito con el estado real (sin abrir el lateral si estaba cerrado).
  function refreshCart() {
    if (isCartPage()) { window.location.reload(); return Promise.resolve(); }
    var cd = document.querySelector('cart-drawer');
    if (!cd || typeof cd.getSectionsToRender !== 'function' || typeof cd.renderContents !== 'function') {
      return getCart().then(renderAll);
    }
    var sections = cd.getSectionsToRender().map(function (s) { return s.section; }).join(',');
    return baseFetch('/cart/update.js', {
      method: 'POST', headers: JSON_HEADERS,
      body: JSON.stringify({ updates: {}, sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      cd.renderContents(state, cd.classList.contains('is-visible'));
      if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
      if (typeof window.updateFreeShipping === 'function') window.updateFreeShipping();
      return getCart().then(renderAll);
    }).catch(function (e) { console.warn(LOG, 'refresh failed', e); });
  }

  // ─── Bloque visual ─────────────────────────────────────────────────
  function optionsHTML(tier) {
    var html = '<option value="">Selecciona modelo y talla…</option>';
    var models = [];
    tier.variants.forEach(function (v) { if (models.indexOf(v.model) === -1) models.push(v.model); });
    models.forEach(function (m) {
      var opts = tier.variants.filter(function (v) { return v.model === m && v.available; });
      if (!opts.length) return;
      html += '<optgroup label="' + esc(m) + '">';
      opts.forEach(function (v) {
        html += '<option value="' + v.id + '">' + esc(m) + ' · Talla ' + esc(v.size) + '</option>';
      });
      html += '</optgroup>';
    });
    return html;
  }

  // ─── Selector visual: modelo (foto + nombre) y talla ─────────────────
  var PICK = {};          // ctx → { model, id }
  var MODEL_IMG = {};     // nombre de modelo → URL de la foto
  var imgLoading = {};
  function loadImages(tier) {
    if (imgLoading[tier.key]) return;
    imgLoading[tier.key] = true;
    baseFetch('/products/regalo-black-november-' + tier.key + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        (p.variants || []).forEach(function (v) {
          var src = (v.featured_image && v.featured_image.src) || '';
          if (src && v.option1 && !MODEL_IMG[v.option1]) MODEL_IMG[v.option1] = src.replace(/([?&])width=\d+&?/, '$1');
        });
        renderAll();
      }).catch(function () {});
  }
  // URL del CDN de Shopify a un ancho concreto (nítida en pantallas de alta densidad).
  function sized(src, w) { return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  function pickerHTML(tier, ctx, opt) {
    opt = opt || {};
    loadImages(tier);
    var models = [];
    tier.variants.forEach(function (v) {
      if (!v.available) return;
      if (models.indexOf(v.model) === -1) models.push(v.model);
    });
    var pick = PICK[ctx] || {};
    if (pick.model && models.indexOf(pick.model) === -1) pick = PICK[ctx] = {};
    var cards = models.map(function (m) {
      var on = pick.model === m ? ' is-on' : '';
      var img = MODEL_IMG[m] ? '<img src="' + esc(sized(MODEL_IMG[m], 400)) + '" srcset="' + esc(sized(MODEL_IMG[m], 300)) + ' 300w, ' +
        esc(sized(MODEL_IMG[m], 600)) + ' 600w, ' + esc(sized(MODEL_IMG[m], 900)) + ' 900w" sizes="(max-width: 480px) 30vw, 160px" alt="" loading="lazy">' : '<span class="bn-gift__ph"></span>';
      return '<button type="button" class="bn-gift__model' + on + '" data-bn-gift-model="' + esc(m) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
        img + '<span>' + esc(m) + '</span></button>';
    }).join('');
    var sizes = '';
    if (pick.model) {
      sizes = '<p class="bn-gift__label">Talla</p><div class="bn-gift__sizes">' + tier.variants.filter(function (v) { return v.model === pick.model; }).map(function (v) {
        var on = String(pick.id) === String(v.id) ? ' is-on' : '';
        return '<button type="button" class="bn-gift__size' + on + '" data-bn-gift-size="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.size) + '</button>';
      }).join('') + '</div>';
    }
    return '<div class="bn-gift__picker">' +
      (opt.noLabel ? '' : '<p class="bn-gift__label">Elige tu guante ' + esc(tier.label) + ' de regalo</p>') +
      '<div class="bn-gift__models">' + cards + '</div>' + sizes +
      '<input type="hidden" data-bn-gift-select value="' + esc(pick.id || '') + '">' +
      '<button type="button" class="bn-gift__add"' + (pick.id ? '' : ' disabled') + ' ' + (opt.addAttr || 'data-bn-gift-add') + '>' +
      (pick.id ? (opt.addLabel || 'Añadir regalo') : pick.model ? 'Elige tu talla' : 'Elige modelo y talla') + '</button>' +
      '<p class="bn-gift__error" data-bn-gift-error hidden></p></div>';
  }

  function blockHTML(a, ctx) {
    var gift = a.gifts[0];
    var giftTier = gift ? TIER_BY_PRODUCT[gift.product_id] || null : null;
    var hasRightGift = !!(gift && a.tier && giftTier === a.tier);

    // Tres casillas, una por franja: conseguida (naranja ✓), la siguiente (cuánto falta) y las demás (desde X €).
    var nextTier = a.tier ? a.next : TIERS[0];
    var tiles = TIERS.map(function (t) {
      var state, sub;
      if (a.tier === t) { state = ' is-on'; sub = 'desde ' + money(t.show); }
      else if (a.total >= t.min) { state = ' is-past'; sub = 'desde ' + money(t.show); }
      else if (t === nextTier) { state = ' is-next'; sub = 'faltan ' + money(t.show - a.total); }
      else { state = ''; sub = 'desde ' + money(t.show); }
      return '<div class="bn-gift__tile' + state + '"><strong>' + esc(t.label) + (a.tier === t ? ' ✓' : '') + '</strong><span>' + sub + '</span></div>';
    }).join('');

    var msg = '', body = '';
    if (a.tier && a.codes.length && !hasRightGift) {
      msg = 'Tienes aplicado el código <strong>' + esc(a.codes.join(', ')) + '</strong>. El guante de regalo ' +
        '<strong>no es acumulable con códigos de descuento</strong>: si prefieres el regalo, quita el código.';
      body = '<div class="bn-gift__row"><button type="button" class="bn-gift__add" data-bn-gift-uncode>' +
        'Quitar código y elegir regalo</button></div><p class="bn-gift__error" data-bn-gift-error hidden></p>';
    } else if (!a.tier) {
      msg = 'Te faltan <strong>' + money(TIERS[0].show - a.total) + '</strong> para llevarte un <strong>guante ' +
        esc(TIERS[0].label) + ' de regalo</strong>.';
    } else if (hasRightGift) {
      var v = GIFT_VARIANT[gift.variant_id];
      var name = v ? v.model : gift.product_title;
      var size = v ? v.size : (gift.variant_title || '');
      var gsrc = gift.image ? String(gift.image).replace(/([?&])width=\d+&?/, '$1') : '';
      var img = gsrc ? '<img class="bn-gift__thumb" src="' + esc(sized(gsrc, 200)) + '" srcset="' + esc(sized(gsrc, 150)) + ' 150w, ' + esc(sized(gsrc, 300)) + ' 300w" sizes="48px" alt="' + esc(name) + '" width="44" height="44" loading="lazy">' : '';
      body = '<div class="bn-gift__chosen">' + img +
        '<div class="bn-gift__chosen-text"><p class="bn-gift__chosen-name">' + esc(name) + (size ? ' · Talla ' + esc(size) : '') + '</p>' +
        '<p class="bn-gift__chosen-sub">Tu regalo · Gratis</p></div>' +
        '<button type="button" class="bn-gift__link" data-bn-gift-remove data-key="' + esc(gift.key) + '">Cambiar</button></div>';
    } else {
      body = pickerHTML(a.tier, ctx);
    }

    return '<div class="bn-gift__head"><p class="bn-gift__eyebrow"><span class="bn-gift__pulse" aria-hidden="true"></span>Black November · Regalo</p><p class="bn-gift__note">1 por pedido</p></div>' +
      '<div class="bn-gift__tiles">' + tiles + '</div>' +
      (msg ? '<p class="bn-gift__msg">' + msg + '</p>' : '') + body +
      '<p class="bn-gift__legal">Hasta el 30/11, sujeto a disponibilidad. No acumulable con códigos de descuento.</p>';
  }

  // Dónde se inserta el bloque
  function targets() {
    var list = [];
    var drawerMain = document.querySelector('#CartDrawer-Body .cart-drawer__main');
    if (drawerMain) list.push({ ctx: 'drawer', parent: drawerMain, before: drawerMain.firstElementChild });
    var pageHeader = document.querySelector('#main-cart-items .cart__main-header');
    if (pageHeader) list.push({ ctx: 'page', parent: pageHeader.parentNode, before: pageHeader.nextElementSibling });
    return list;
  }

  var rendering = false;
  function renderAll() {
    if (!lastCart) return;
    var a = analyse(lastCart);
    rendering = true;
    try {
      targets().forEach(function (t) {
        var box = t.parent.querySelector(':scope > [data-bn-gift]');
        if (!a.count) { if (box) box.remove(); return; }
        if (!box) {
          box = document.createElement('div');
          box.setAttribute('data-bn-gift', '');
          box.className = 'bn-gift bn-gift--' + t.ctx;
          t.parent.insertBefore(box, t.before);
        }
        var html = blockHTML(a, t.ctx);
        if (box.__bnHtml !== html) {
          box.innerHTML = html;
          box.__bnHtml = html;
        }
        // Aviso visual mientras el cliente tiene un regalo pendiente de elegir.
        box.classList.toggle('is-action', !!box.querySelector('.bn-gift__picker'));
      });
      renderModal(a);
    } finally {
      rendering = false;
    }
  }

  // El tema reemplaza el HTML del carrito al cambiarlo → reinsertamos el bloque.
  var moTimer = null;
  new MutationObserver(function () {
    if (rendering || moTimer) return;
    moTimer = setTimeout(function () {
      moTimer = null;
      var missing = targets().some(function (t) { return !t.parent.querySelector(':scope > [data-bn-gift]'); });
      if (missing) renderAll();
    }, 50);
  }).observe(document.body, { childList: true, subtree: true });

  // ─── Coherencia del carrito ─────────────────────────────────────────
  var running = false, pending = false, timer = null;
  function scheduleReconcile(delay) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(reconcile, delay == null ? 600 : delay);
  }

  async function reconcile() {
    if (running) { pending = true; return; }
    running = true;
    var changed = false;
    try {
      var cart = await getCart();
      var a = analyse(cart);
      if (a.gifts.length && cart.attributes && cart.attributes[DECLINE_ATTR]) {
        await setDecline('');
      }
      if (a.gifts.length) {
        for (var i = 1; i < a.gifts.length; i++) { await setQty(a.gifts[i].key, 0); changed = true; }
        var gift = a.gifts[0];
        var giftTier = TIER_BY_PRODUCT[gift.product_id];
        if (a.codes.length && gift.final_line_price > 0) {
          // Hay un código y Shopify lo ha preferido al regalo → el regalo se cobraría: lo quitamos.
          await setQty(gift.key, 0); changed = true;
        } else if (!a.tier || !giftTier) {
          await setQty(gift.key, 0); changed = true;
        } else if (giftTier !== a.tier) {
          var swap = findSwapVariant(gift, a.tier);
          await setQty(gift.key, 0); changed = true;
          if (swap) await addGift(swap.id);
        } else if (gift.quantity > 1) {
          await setQty(gift.key, 1); changed = true;
        }
      }
    } catch (e) {
      console.warn(LOG, 'reconcile failed', e);
    } finally {
      running = false;
      if (changed) await refreshCart(); else renderAll();
      if (pending) { pending = false; scheduleReconcile(300); }
    }
  }

  // Cambios de carrito hechos por el tema u otras apps → revisar y repintar.
  var themeFetch = window.fetch;
  window.fetch = function (input) {
    var p = themeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (res) { if (res && res.ok) scheduleReconcile(); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };
  document.addEventListener('cart:refresh', function () { scheduleReconcile(); });

  // ─── Clicks del bloque ──────────────────────────────────────────────
  function showError(box, msg) {
    var el = box && box.querySelector('[data-bn-gift-error]');
    if (!el) return;
    el.textContent = msg; el.hidden = !msg;
  }
  function setBusy(box, busy) {
    if (!box) return;
    box.classList.toggle('is-busy', busy);
    box.querySelectorAll('button, select').forEach(function (b) { b.disabled = busy; });
  }

  // Selector visual: elegir modelo y talla (sin cerrar el carrito lateral).
  document.addEventListener('click', function (e) {
    var m = e.target.closest && e.target.closest('[data-bn-gift-model]');
    var z = e.target.closest && e.target.closest('[data-bn-gift-size]');
    if (!m && !z) return;
    e.preventDefault(); e.stopPropagation();
    var box = (m || z).closest('[data-bn-gift], [data-bn-gift-modal]');
    var ctx = box && box.getAttribute('data-bn-ctx') || (box && /bn-gift--page/.test(box.className) ? 'page' : 'drawer');
    if (m) PICK[ctx] = { model: m.getAttribute('data-bn-gift-model'), id: '' };
    else if (!z.disabled) { PICK[ctx] = PICK[ctx] || {}; PICK[ctx].id = z.getAttribute('data-bn-gift-size'); }
    renderAll();
  }, true);

  document.addEventListener('click', async function (e) {
    var addBtn = e.target.closest && e.target.closest('[data-bn-gift-add]');
    var rmBtn = e.target.closest && e.target.closest('[data-bn-gift-remove]');
    var ucBtn = e.target.closest && e.target.closest('[data-bn-gift-uncode]');
    if (!addBtn && !rmBtn && !ucBtn) return;
    e.preventDefault();
    e.stopPropagation(); // que el clic no cierre el carrito lateral
    var box = (addBtn || rmBtn || ucBtn).closest('[data-bn-gift]');

    if (ucBtn) {
      setBusy(box, true);
      try {
        var r = await baseFetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ discount: '' }) });
        if (!r.ok) throw new Error('HTTP ' + r.status);
      } catch (err) {
        console.warn(LOG, 'remove code failed', err);
        setBusy(box, false);
        showError(box, 'No hemos podido quitar el código. Quítalo en el carrito o en la página de pago.');
        return;
      }
      await refreshCart();
      setBusy(box, false);
      return;
    }

    if (rmBtn) {
      setBusy(box, true);
      try { await setQty(rmBtn.dataset.key, 0); } catch (err) {}
      await refreshCart();
      setBusy(box, false);
      return;
    }

    var sel = box.querySelector('[data-bn-gift-select]');
    if (!sel || !sel.value) { showError(box, 'Elige modelo y talla de tu guante de regalo.'); return; }
    var chosen = Number(sel.value);
    showError(box, '');
    setBusy(box, true);
    try {
      var cart = await getCart();
      var a = analyse(cart);
      var v = GIFT_VARIANT[chosen];
      if (!a.tier || !v || v.tier !== a.tier) { await refreshCart(); return; }
      for (var i = 0; i < a.gifts.length; i++) await setQty(a.gifts[i].key, 0);
      var res = await addGift(chosen);
      if (!res.ok) {
        var data = {}; try { data = await res.json(); } catch (x) {}
        setBusy(box, false);
        showError(box, data.description || 'No hemos podido añadir el regalo. Prueba con otra talla.');
        return;
      }
      PICK = {};
      await refreshCart();
    } catch (err) {
      console.warn(LOG, 'add failed', err);
      showError(box, 'No hemos podido añadir el regalo. Inténtalo de nuevo.');
    } finally {
      if (box && box.isConnected) setBusy(box, false);
    }
  }, true);

  // ─── Aviso antes de pagar: «Te falta tu guante de regalo» ─────────────
  // Sale al pulsar «Finalizar compra» (carrito lateral y /cart) si el pedido llega a una franja,
  // no tiene regalo y no tiene código aplicado. El cliente elige modelo y talla (nada preseleccionado)
  // o pulsa «No quiero regalo»; en ese caso el pedido lo indica en «Información adicional».
  var DECLINE_ATTR = 'Regalo Black November';
  var DECLINE_PREFIX = 'NO LO QUISO';
  var MODAL = null;        // { el, tier, btn }

  function setDecline(value) {
    var attrs = {}; attrs[DECLINE_ATTR] = value;
    return baseFetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { if (lastCart) { lastCart.attributes = lastCart.attributes || {}; lastCart.attributes[DECLINE_ATTR] = value; } return r; });
  }
  function declinedTierIndex(cart) {
    var v = cart && cart.attributes && cart.attributes[DECLINE_ATTR];
    if (!v || v.indexOf(DECLINE_PREFIX) !== 0) return -1;
    for (var i = TIERS.length - 1; i >= 0; i--) { if (v.indexOf(TIERS[i].label) !== -1) return i; }
    return -1;
  }
  function needsGiftPrompt(cart) {
    if (!cart || !cart.item_count) return null;
    var a = analyse(cart);
    if (!a.tier || a.codes.length) return null;
    var gift = a.gifts[0];
    if (gift && TIER_BY_PRODUCT[gift.product_id] === a.tier) return null;
    if (!a.tier.variants.some(function (v) { return v.available; })) return null;
    if (declinedTierIndex(cart) >= TIERS.indexOf(a.tier)) return null; // ya dijo que no (en esta franja o una superior)
    return a.tier;
  }

  function injectModalCSS() {
    if (document.getElementById('bn-gift-modal-css')) return;
    var st = document.createElement('style');
    st.id = 'bn-gift-modal-css';
    st.textContent =
      '.bn-gmodal{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(10,10,10,.55);}' +
      '.bn-gmodal__card{position:relative;width:100%;max-width:440px;max-height:calc(100vh - 32px);overflow:auto;background:#fff;color:#0a0a0a;border-radius:14px;padding:22px 18px 18px;box-shadow:0 20px 60px rgba(0,0,0,.3);font-size:14px;}' +
      '.bn-gmodal__close{position:absolute;top:8px;right:8px;width:36px;height:36px;border:0;background:none;font-size:22px;line-height:1;cursor:pointer;color:#5c5853;}' +
      '.bn-gmodal__eyebrow{margin:0 0 6px;font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#C2410C;}' +
      '.bn-gmodal__title{margin:0 0 6px;font-size:20px;font-weight:800;line-height:1.2;}' +
      '.bn-gmodal__text{margin:0 0 14px;font-size:14px;line-height:1.4;color:#3d3a36;}' +
      '.bn-gmodal .bn-gift{border:0 !important;padding:0 !important;}' +
      '.bn-gmodal__no{display:block;width:100%;margin-top:10px;min-height:44px;border:1px solid #d9d5d0;border-radius:8px;background:#fff;color:#0a0a0a;font:inherit;font-size:14px;font-weight:600;cursor:pointer;}' +
      '.bn-gmodal__legal{margin:12px 0 0;font-size:11px;color:#8a857f;}' +
      '@media (max-width:480px){.bn-gmodal{align-items:flex-end;padding:0;}.bn-gmodal__card{max-width:none;border-radius:16px 16px 0 0;max-height:92vh;padding-bottom:calc(18px + env(safe-area-inset-bottom));}}';
    document.head.appendChild(st);
  }

  function modalInner(tier) {
    return '<button type="button" class="bn-gmodal__close" data-bn-modal-close aria-label="Cerrar">×</button>' +
      '<p class="bn-gmodal__eyebrow">Black November · Regalo</p>' +
      '<p class="bn-gmodal__title" id="bn-gmodal-title">🎁 Te falta tu guante de regalo</p>' +
      '<p class="bn-gmodal__text">Tu pedido incluye un <strong>guante ' + esc(tier.label) + ' gratis</strong>. Elige modelo y talla.</p>' +
      '<div class="bn-gift" data-bn-gift-modal data-bn-ctx="modal">' +
      pickerHTML(tier, 'modal', { addAttr: 'data-bn-modal-add', addLabel: 'Añadir regalo y pagar', noLabel: true }) + '</div>' +
      '<button type="button" class="bn-gmodal__no" data-bn-modal-decline>No quiero regalo</button>' +
      '<p class="bn-gmodal__legal">Hasta el 30/11, sujeto a disponibilidad. No acumulable con códigos de descuento.</p>';
  }
  function renderModal(a) {
    if (!MODAL) return;
    var box = MODAL.el.querySelector('[data-bn-gift-modal]');
    if (!box) return;
    if (a && a.tier && a.tier !== MODAL.tier) { closeModal(); return; }
    var html = pickerHTML(MODAL.tier, 'modal', { addAttr: 'data-bn-modal-add', addLabel: 'Añadir regalo y pagar', noLabel: true });
    if (box.__bnHtml !== html) { box.innerHTML = html; box.__bnHtml = html; }
  }
  function openModal(tier, btn) {
    injectModalCSS();
    closeModal();
    PICK.modal = {};
    var el = document.createElement('div');
    el.className = 'bn-gmodal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'bn-gmodal-title');
    el.innerHTML = '<div class="bn-gmodal__card">' + modalInner(tier) + '</div>';
    document.body.appendChild(el);
    MODAL = { el: el, tier: tier, btn: btn };
    var first = el.querySelector('[data-bn-gift-model]');
    if (first) try { first.focus({ preventScroll: true }); } catch (x) {}
  }
  function closeModal() {
    if (MODAL && MODAL.el.parentNode) MODAL.el.parentNode.removeChild(MODAL.el);
    MODAL = null;
  }
  // Va directo al pago. No se reenvía el formulario del carrito: llevaría las cantidades de antes
  // de añadir el regalo y se las aplicaría a la línea equivocada. Solo se guarda la nota del pedido.
  async function continueCheckout(btn) {
    var form = btn && btn.form;
    var note = form && form.elements && form.elements.note;
    if (note && typeof note.value === 'string' && lastCart && note.value !== (lastCart.note || '')) {
      try { await baseFetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ note: note.value }) }); } catch (x) {}
    }
    closeModal();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'checkout';
  }
  function modalError(msg) {
    var el = MODAL && MODAL.el.querySelector('[data-bn-gift-error]');
    if (el) { el.textContent = msg; el.hidden = !msg; }
  }
  function modalBusy(busy) {
    if (!MODAL) return;
    MODAL.el.querySelectorAll('button').forEach(function (b) { b.disabled = busy; });
  }

  // Intercepta «Finalizar compra»
  var CHECKOUT_SEL = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"]';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(CHECKOUT_SEL);
    if (!btn || (MODAL && MODAL.el.contains(btn))) return;
    // Primero las validaciones del tema (casilla «Acepto las condiciones…»): si faltan, que las muestre el navegador.
    if (btn.form && typeof btn.form.checkValidity === 'function' && !btn.form.checkValidity()) return;
    var tier = needsGiftPrompt(lastCart);
    if (!tier) return;
    e.preventDefault(); e.stopPropagation();
    openModal(tier, btn);
    // Confirma con el carrito real (por si ha cambiado); si ya no hace falta, sigue al pago.
    getCart().then(function (c) {
      var t = needsGiftPrompt(c);
      if (!t) { if (MODAL) continueCheckout(btn); }
      else if (MODAL && t !== MODAL.tier) openModal(t, btn);
    }).catch(function () {});
  }, true);
  // Intro en el formulario del carrito (submit sin clic)
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (!sub || sub.name !== 'checkout') return;
    var tier = needsGiftPrompt(lastCart);
    if (!tier) return;
    e.preventDefault(); e.stopPropagation();
    openModal(tier, sub);
  }, true);

  // Botones del aviso
  document.addEventListener('click', async function (e) {
    if (!MODAL || !MODAL.el.contains(e.target)) return;
    e.stopPropagation(); // que no cierre el carrito lateral
    var t = e.target;
    if (t === MODAL.el || (t.closest && t.closest('[data-bn-modal-close]'))) { e.preventDefault(); closeModal(); return; }
    var btn = MODAL.btn;
    if (t.closest && t.closest('[data-bn-modal-decline]')) {
      e.preventDefault();
      modalBusy(true);
      try { await setDecline(DECLINE_PREFIX + ' (franja ' + MODAL.tier.label + ')'); } catch (x) {}
      continueCheckout(btn);
      return;
    }
    if (t.closest && t.closest('[data-bn-modal-add]')) {
      e.preventDefault();
      var pick = PICK.modal || {};
      if (!pick.id) { modalError('Elige modelo y talla de tu guante de regalo.'); return; }
      modalError(''); modalBusy(true);
      try {
        var cart = await getCart();
        var a = analyse(cart);
        var v = GIFT_VARIANT[pick.id];
        if (!a.tier || !v || v.tier !== a.tier) { modalBusy(false); closeModal(); refreshCart(); return; }
        for (var i = 0; i < a.gifts.length; i++) await setQty(a.gifts[i].key, 0);
        var res = await addGift(pick.id);
        if (!res.ok) {
          var data = {}; try { data = await res.json(); } catch (x) {}
          modalBusy(false);
          modalError(data.description || 'No hemos podido añadir el regalo. Prueba con otra talla.');
          return;
        }
        if (cart.attributes && cart.attributes[DECLINE_ATTR]) { try { await setDecline(''); } catch (x) {} }
        PICK = {};
        await getCart();
        continueCheckout(btn);
      } catch (err) {
        console.warn(LOG, 'modal add failed', err);
        modalBusy(false);
        modalError('No hemos podido añadir el regalo. Inténtalo de nuevo.');
      }
    }
  }, true);
  document.addEventListener('keydown', function (e) { if (MODAL && e.key === 'Escape') closeModal(); });

  // Arranque
  getCart().then(function () { renderAll(); if (CFG.itemCount > 0) scheduleReconcile(300); })
    .catch(function (e) { console.warn(LOG, 'init failed', e); });
})();